var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F7F8F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8191 12.1343L9.18971 7.02478C9.17238 7.01133 9.15156 7.00296 9.12964 7.00065C9.10772 6.99834 9.08558 7.00218 9.06577 7.01173C9.04596 7.02128 9.02928 7.03615 9.01765 7.05463C9.00601 7.07311 8.9999 7.09445 9 7.1162V8.23794C9 8.30904 9.03382 8.37725 9.08971 8.42078L14.3838 12.4999L9.08971 16.5791C9.03235 16.6226 9 16.6908 9 16.7619V17.8837C9 17.9809 9.11324 18.0346 9.18971 17.9751L15.8191 12.8656C15.8754 12.8223 15.921 12.7668 15.9524 12.7034C15.9837 12.64 16 12.5705 16 12.4999C16 12.4294 15.9837 12.3598 15.9524 12.2965C15.921 12.2331 15.8754 12.1776 15.8191 12.1343Z",
    fill: "#4A4A68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.c4dfdf8a7c642cd75c3eb26172fe2a8f.svg";
export { ForwardRef as ReactComponent };